export enum EColor {
  weiss = '#ffffff',
  grau = '#f2efed',
  gruen = '#2b5149'
}
